<template>
    <div>
        <div class="mb10">
            <el-page-header @back="toListPage" content="素材内容导出">
                <span slot="title" class="font14px text-bold" v-matomo="{behaviorCategory: '自助工具(素材内容导出)', event: '点击',  name: '返回'}">返回</span>
                <span slot="content" class="font14px text-color-gray">素材内容导出</span>
            </el-page-header>
        </div>
        <div class="form-wrap">
            <el-form :model="formItem" :rules="rules" ref="form" @submit.native.prevent label-position="top" label-width="150px">
                <el-form-item label="媒体：" prop="plat_id">
                    <el-radio-group v-model="formItem.plat_id" @change="changePlat">
                        <el-radio-button v-if="allowedPlatIds.includes('1')" label="1">OPPO</el-radio-button>
                        <el-radio-button v-if="allowedPlatIds.includes('3')" label="3">vivo</el-radio-button>
                        <!--<el-radio-button v-if="allowedPlatIds.includes('4')" label="4">华为</el-radio-button>-->
                        <!--<el-radio-button v-if="allowedPlatIds.includes('8')" label="8">爱奇艺</el-radio-button>-->
                        <!--<el-radio-button v-if="allowedPlatIds.includes('9')" label="9">Apple</el-radio-button>-->
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="创意ID：" prop="ad_ids">
                    <el-input
                        type="textarea"
                        :rows="6"
                        placeholder='输入或粘贴创意ID，多个创意ID支持使用[英文逗号","] [英文分号";"] [换行]分割'
                        v-model="formItem.ad_ids">
                    </el-input>
                </el-form-item>
                <el-form-item label="选择字段：" prop="fields">
                    <el-checkbox-group v-model="formItem.fields">
                        <el-checkbox label="img_url,video_url" value="img_url,video_url">素材链接</el-checkbox>
                        <!--<el-checkbox label="素材名称" value="material_name"></el-checkbox>-->
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="">
                    <div class="dialog-footer tac">
                        <el-button type="default" @click="toListPage" class="action-btn mr20" v-matomo="{behaviorCategory: '自助工具(素材内容导出)', event: '点击',  name: '取消'}">取消</el-button>
                        <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20" v-matomo="{behaviorCategory: '自助工具(素材内容导出)', event: '点击',  name: '导出'}">导出</el-button>
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import API from '@/api/efficiencyTool/assisttools.js';

    export default {
        name: "MaterialExportPage",
        props:{
            allowedPlatIds:Array,
        },
        data(){
            return {
                formItem:{
                    plat_id:'',
                    ad_ids:'',
                    fields:['img_url,video_url'],
                },
                rules:{
                    plat_id:[
                        { required: true, message: '请选择媒体', trigger: 'change' },
                    ],
                    ad_ids:[
                        { required: true, message: '创意ID不能为空', trigger: 'blur' },
                    ],
                    fields:[
                        { type: 'array', required: true, message: '请选择导出字段', trigger: 'change' }
                    ],
                },
                submitLoading:false,
            }
        },
        mounted(){
            console.log('mounted',this.allowedPlatIds);
            this.setDefaultPlat()
        },
        methods:{
            setDefaultPlat(){
                let platList = this.allowedPlatIds||[];
                /* 目前仅支持OPPO、vivo渠道 */
                if(platList.includes('1')||platList.includes(1)){
                    this.formItem.plat_id = '1';
                }else if(platList.includes('3')||platList.includes(3)){
                    this.formItem.plat_id = '3';
                }
            },
            toListPage(){
                console.log('toListPage');
                this.resetForm();
                this.$emit('back');
            },
            resetForm(){
                console.log('resetForm');
                this.$refs.form.resetFields();
                this.setDefaultPlat();
            },
            changePlat(val){
                console.log('changePlat',val);
                // this.formItem.ad_ids = '';
            },
            handleSubmit(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        console.log('handleSubmit',API.exportMaterial);

                        let adIds = this.formItem.ad_ids.replace(/[;\r\n]/gm,',').replace(/,+/g,',');

                        this.submitLoading = true;
                        API.exportMaterial({
                            plat_id:this.formItem.plat_id,
                            ad_ids:adIds,
                            fields:this.formItem.fields.join(','),
                        }).then(res=>{
                            console.log('exportMaterial',res);

                            this.submitLoading = false;
                            this.$message.success(res.info||'');
                            this.resetForm();

                        },err=>{
                            console.log('exportMaterial err',err);
                            this.submitLoading = false;

                            let errData = err.data||[];
                            if(err.code==0&&errData.length>0){
                                this.$alert(err.info||'请求失败',{
                                    type:'error',
                                    title: err.info||'请求失败',
                                    dangerouslyUseHTMLString: true,
                                    message: "<div class='font12px' style='max-height: 300px;overflow-y: auto;word-break: break-all;'>"+errData.join('、')+"</div>",
                                    duration: 0
                                });
                            }else{
                                this.$message.error(err.info||'操作失败');
                            }
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .form-wrap{
        max-width: 1000px;
        margin: 20px 10px 10px;
    }
</style>
